import { useQuery } from '@tanstack/react-query';

import dtStatus from '../../status';
import fetch from './fetch';

function useDtPortfolio() {
  const { cb, key } = fetch();

  const { isDtActive } = dtStatus.useDtAccountStatus();

  const enabled = isDtActive; // Do not call when user does not have DT account

  const { data, isSuccess, refetch } = useQuery(key, cb, {
    enabled,
    staleTime: 5000,
    cacheTime: 5000,
    refetchOnWindowFocus: false,
  });

  return { data, isSuccess, refetch };
}

export default useDtPortfolio;
